export const wait = (miliseconds = 0) =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise((resolve) => setTimeout(resolve, miliseconds));
